import { Component } from '@angular/core';

@Component({
  selector: 'wchfs-nav-list-item',
  templateUrl: './nav-list-item.component.html',
  styleUrls: ['./nav-list-item.component.scss'],
})
export class NavListItemComponent {}
